export default __webpack_public_path__ + "static/media/NAVTEQ.78667f54.png";